import React from 'react';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import {
  MultiDropdown,
  useMultiDropdown,
} from '@grnhse/seedling/lib/birch/components/forms/dropdown';
import type { Item } from '@grnhse/seedling/lib/birch/components/forms/dropdown/item';
import CandidateIcon from '@grnhse/seedling/lib/birch/icons/candidate';
import { withLocalePrefix } from 'shared/utils/translation';
import { useUserContext } from 'talent_matching/contexts/user_context';
import { useBookmarkUsers } from 'talent_matching/api';
import PopoverButton from 'talent_matching/components/filters/popover_button';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';

const t = withLocalePrefix('talent_matching.filter_row.bookmarked_by_teammate');

const BookmarkedByTeammate = () => {
  const { watch, setValue } = useFormContext();
  const {
    paths: { bookmarkUsersPath },
  } = useUserContext();

  const { data: users = [] } = useBookmarkUsers(bookmarkUsersPath);
  const selected: Item[] = watch('bookmarkedByTeammates') || [];

  const items: Item[] = users.map((u) => ({
    value: u.id.toString(),
    label: u.name,
  }));

  const dropdownProps = useMultiDropdown({
    items,
    selectedItems: selected,
    onSelectedItemsChange: (changes) =>
      setValue('bookmarkedByTeammates', changes.selectedItems, {
        shouldDirty: true,
      }),
  });

  if (users.length === 0) {
    return null;
  }

  const count = selected.length;
  const buttonLabel = `${t('title')}${count ? ` (${count})` : ''}`;
  const Icon = CandidateIcon;

  return (
    <PopoverButton
      buttonLabel={buttonLabel}
      title={t('title')}
      icon={Icon}
      width="360px"
    >
      <Stack direction="row" spacing={1}>
        <MultiDropdown dropdownProps={dropdownProps}>
          <MultiDropdown.Field
            placeholder={t('placeholder')}
            ariaLabel={t('title')}
            condensedUnitName={t('selections')}
          />
          <MultiDropdown.Flyout disablePortal />
        </MultiDropdown>
      </Stack>
    </PopoverButton>
  );
};

export default BookmarkedByTeammate;
